// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"a5fb8279","496":"854f2072"}[chunkId] + ".chunk.js";
};